  <app-user-dashboard>
      <div  *ngIf="programOrderGuid">
        <app-assign-stock
          #assignStockComponent [isProgramLoad]="true"
          [editProgramFromStock]="true"
          [programOrderGuid]="programOrderGuid"/>
      </div>
    </app-user-dashboard>
